import { navigationMap } from "./navigationMap";

export const customNavigationMap = {
  ...navigationMap,
  PurchaseIrqNotSupportedPage: {
    ...navigationMap.PurchaseIrqNotSupportedPage,
    Primary: { external: true, newTab: false, url: "/" },
  },
  BuildIrqNotSupportedPage: {
    ...navigationMap.BuildIrqNotSupportedPage,
    Primary: { external: true, newTab: false, url: "/" },
  },
  RefinanceIrqNotSupportedPage: {
    ...navigationMap.RefinanceIrqNotSupportedPage,
    Primary: { external: true, newTab: false, url: "/" },
  },
  BuyPreApprovedApplyNowPage: {
    ...navigationMap.BuyPreApprovedApplyNowPage,
    Primary: { external: true, newTab: false, url: "/apply" },
  },
  BuyPreApprovedWithOtherPage: {
    ...navigationMap.BuyPreApprovedWithOtherPage,
    Primary: { external: true, newTab: false, url: "/" },
  },
  BuyDoYouWantHypotheticalQuotePage: {
    ...navigationMap.BuyDoYouWantHypotheticalQuotePage,
    Secondary: {
      external: true,
      newTab: false,
      url: "/learn/first-time-homebuyer-guide",
    },
  },
  BuyDoYouWantToApplyPreapprovalFirstTimePage: {
    ...navigationMap.BuyDoYouWantToApplyPreapprovalFirstTimePage,
    Primary: { external: true, newTab: false, url: "/pre-approval" },
  },
  BuyDoYouWantToApplyForPreapprovalNotFirstTimePage: {
    ...navigationMap.BuyDoYouWantToApplyForPreapprovalNotFirstTimePage,
    Primary: { external: true, newTab: false, url: "/pre-approval" },
  },
  BuildWhatNextPage: {
    ...navigationMap.BuildWhatNextPage,
    Secondary: { external: true, newTab: false, url: "/pre-approval" },
    Tertiary: { external: true, newTab: false, url: "/apply" },
    Danger: { external: true, newTab: false, url: "/" },
  },
};
